export default "﻿<div class=\"empty-view\">\r\n</div>"